import { INavMenuItem } from "@types";
import React from "react";
import * as S from "../../style/DesktopNavbar.styled";
import Sidebar from "./Sidebar";

interface NavbarSubmenuProps {
  submenu: INavMenuItem[] | null;
  submenuHeight: number;
  setActiveSubmenu: (value: INavMenuItem[] | null) => void;
}

const NavbarSubmenu: React.FC<NavbarSubmenuProps> = ({
  submenu,
  submenuHeight,
  setActiveSubmenu,
}) => {
  if (!submenu) return null;

  return (
    <S.Submenu
      onMouseLeave={() => setActiveSubmenu(null)}
      height={submenuHeight}
    >
      <Sidebar sidemenu={submenu} />
    </S.Submenu>
  );
};

export default NavbarSubmenu;
